import React from 'react';
import { Tag } from '@cp/ds/src/components/tag';
import { LogoIcon } from '@cp/ds/src/icons';

export interface SchoolYouHelpTagProps {
  trainingCompletedAt?: string;
}

export const SchoolYouHelpTag: React.FC<SchoolYouHelpTagProps> = ({ trainingCompletedAt }) => {
  if (!trainingCompletedAt) {
    return null;
  }

  return (
    <Tag iconLeft={<LogoIcon fontSize="small" />} size="small">
      Школа YouHelp
    </Tag>
  );
};
